import React     from 'react';
import PropTypes from 'prop-types';

import ProfileHeaderButtons from '../../ProfileHeader/ProfileHeaderButtons';
import Pin                  from '../../Favorite/Actor/Pin';
import Note                 from '../../Favorite/Actor/Note';
import ActorProfileBadges   from './ActorProfileBadges';

import UrlBuilder   from '../../../utils/UrlBuilder';
import Translations from '../../../utils/Translations';

const ActorProfileDetails = (props) => {
    const {lineBreak, actorData, openViewer, serviceNumberItem, isService0900Available} = props;

    const profileImage = {
        actorName:  actorData.name,
        actorUrl:   actorData.profileLink,
        blurImage:  false,
        needBuying: false,
        origUrl:    actorData.previewPictureBig,
        previewUrl: actorData.previewPicture,
        title:      Translations.get('actor_profile.header-viewer.title'),
        titleUrl:    actorData.profileLink,
        type:       "photo",
        url:        actorData.previewPictureBig,
        width:      1864,
    };

    return (
            <div className='actor-profile-header-details__container'>

                {/* Actor Details */}
                <div className={`actor-profile-header-details ${lineBreak ? 'actor-profile-header-details--line-break' : ''}`}>

                    {/* Actor Avatar */}
                    <div
                        onClick   = {(e)=>openViewer(profileImage, e)}
                        className = {'actor-profile-header-avatar actor-status -size-xl ' + (actorData.isOnline ? 'is-online' : actorData.isOnlineMobileVideocall ? 'is-videocall' : 'is-offline')}
                        style     = {{
                            backgroundImage: `url(${actorData.previewPicture})`,
                            backgroundSize:  'cover',
                            cursor:          'pointer',
                        }}
                    />

                    {/* Actor name, age and Favorite Pin */}
                    <div className='actor-profile-header__info-container'>
                        <ActorProfileBadges
                            isLivePreviewEnabled = {actorData.isLivePreviewEnabled}
                            isChatQualityHD      = {actorData.isChatQualityHD}
                            isStar               = {actorData.isStar}
                            spokenLanguages      = {actorData.spokenLanguages}
                        />
                        {actorData.isPlaceholder
                            ? <>
                                <div className='actor-profile-header__model-info'>
                                    <div className='actor-profile-header__name h-left actor-profile-header__name--placeholder'/>
                                </div>
                                <div
                                    className='actor-profile-header__name actor-profile-header__name--placeholder -sm'

                                />
                            </>
                            :
                            <>
                                <div className='actor-profile-header__model-info'>
                                    <a
                                        href      = {UrlBuilder.buildActorProfileUrl(actorData.name)}
                                        className = 'actor-profile-header__name h-left'
                                    >
                                        {actorData.name}
                                    </a>
                                    <span className='actor-profile-header__age h-left'>({actorData.age})</span>
                                    <span className='actor-profile-header__pin h-left'>
                                        <Pin
                                            actorId                  = {actorData.id}
                                            initialIsFavoriteOfGuest = {actorData.isFavorite}
                                        />
                                    </span>
                                    <div className="actor-profile-header__note h-left">
                                        <Note
                                            actorId   = {actorData.id}
                                            autoClose = {true}
                                        />
                                    </div>
                                </div>
                                <div
                                    className='actor-profile-header__text h-text-capitalize-first h-text-italic h-left'
                                    dangerouslySetInnerHTML={{__html: actorData.showText}}
                                />
                            </>
                        }

                    </div>

                    {actorData.id !== 5613624 && actorData.prices && <ProfileHeaderButtons          // Don't show buttons for Lucy Cat
                        actorId                           = {actorData.id}
                        actorLink                         = {actorData.profileLink}
                        freeShowBegin                     = {actorData.freeChatBegin}
                        freeShowData                      = {actorData.freeChat}
                        freeShowEnd                       = {actorData.freeChatEnd}
                        isActorAvailableForConversionChat = {actorData.isAvailableForConversionChat}
                        isActorOnline                     = {actorData.isOnline}
                        isBannedCountryCode               = {actorData.isBannedCountryCode}
                        isCurrentlyTicketShow             = {actorData.isCurrentlyTicketShow}
                        isLivePreviewEnabled              = {actorData.isLivePreviewEnabled}
                        isLobbyChat                       = {actorData.isLobbyChat}
                        isOnlineMobileVideocall           = {actorData.isOnlineMobileVideocall}
                        isService0900Busy                 = {actorData.isService0900Busy}
                        isVoyeurChatAvailable             = {actorData.isVoyeurChatAvailable}
                        multiChatPrice                    = {actorData.prices?.video}
                        messagePrice                      = {actorData.prices?.message}
                        onlyVideochatButton               = {actorData.onlyVideochatButton}
                        profileLink                       = {""}
                        privateChatPrice                  = {actorData.prices?.single}
                        serviceNumberItem                 = {serviceNumberItem}
                        singleC2CChatPrice                = {actorData.prices?.singlec2c}
                        voucherChatMinutes                = {actorData.prices?.voucherChatMinutes}
                        voyeurChatPrice                   = {actorData.prices?.voyeur}
                        isPlaceholder                     = {actorData.isPlaceholder}
                        isService0900Available            = {isService0900Available}
                    />}
                </div>
            </div>
    )
}

ActorProfileDetails.propTypes = {
    actorData:     PropTypes.object.isRequired,
    openViewer:    PropTypes.func.isRequired,
    lineBreak:     PropTypes.bool,
}

export default ActorProfileDetails
